export enum StatusHttp {
    Success = 200,
    ServerError = 500
}

export enum AppStorageKey {
    AuthTokenObject = 'paco.app.token',
    DeviceInformation = 'paco.device.information',
    CustomColors = 'paco.custom.colors',
    OneSignalUserToken = 'onesignal.user.token',
    IsOpenFromNotification = 'onesignal.isOpenFromNotification.token',
    HasDebtsToken = 'debts.token'
}